exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* ---------- COLORS ----------*/\n#orgunitContainer .xs-primary-contact {\n  font-weight: 500;\n}\n#orgunitContainer .xs-contact-form {\n  margin-top: 20px;\n}\n#orgunitContainer .xs-contact-form .xs-checkbox {\n  height: 20px;\n}\n#orgunitContainer .xs-contact-form .xs-checkbox-cover {\n  display: flex;\n  flex-direction: row;\n  width: 8.3333%;\n  margin-top: 5px;\n}\n#orgunitContainer .xs-contact-form .xs-form-actions {\n  padding-bottom: 0px;\n  text-align: right;\n}\n.OrgunitForm .xs-orgunit-paper {\n  padding: 20px;\n}\n", ""]);

// exports
